import { render, staticRenderFns } from "./ShopPaymentPage.vue?vue&type=template&id=dd0f7238&scoped=true&"
import script from "./ShopPaymentPage.vue?vue&type=script&lang=js&"
export * from "./ShopPaymentPage.vue?vue&type=script&lang=js&"
import style0 from "./ShopPaymentPage.vue?vue&type=style&index=0&id=dd0f7238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0f7238",
  null
  
)

export default component.exports